import React from "react";
import { Box, Drawer } from "@mui/material";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import * as selectors from "selectors";
import { getSidebarConfig } from "./sidebarConfig";
import SidebarNavGroup from "./SidebarNavGroup";
import SidebarNavItem from "./SidebarNavItem";

const DRAWER_WIDTH = 280;

export const ClientSidebar: React.FC = () => {
  const { section } = useParams<{ section: string }>();
  const userPermissions = useSelector(selectors.getUserPermissionsList);
  const sidebarConfig = getSidebarConfig(userPermissions);

  const drawerContent = (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        paddingBottom: "24px",
      }}
    >
      <Box sx={{ flex: 1 }}>
        {sidebarConfig.map((item) =>
          "items" in item ? (
            <SidebarNavGroup
              key={item.label}
              group={item}
              activeSection={section}
            />
          ) : (
            <SidebarNavItem
              key={item.path}
              item={item}
              isActive={section === item.path}
            />
          )
        )}
      </Box>
    </Box>
  );

  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: "none", md: "flex" },
        flexDirection: "column",
        height: "100%",
        minHeight: 0,
        "& .MuiDrawer-paper": {
          width: DRAWER_WIDTH,
          boxSizing: "border-box",
          border: "0px",
          position: "relative",
          height: "100%",
          zIndex: 1,
        },
      }}
      open
    >
      {drawerContent}
    </Drawer>
  );
};

export default ClientSidebar;
